import { Badge, Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

interface ExpiryAlertBadgeProps {
  mdIsExpiringSoon: boolean;
  mdExpiryDate?: string | null;
}

export default function ExpiryAlertBadge({ mdIsExpiringSoon, mdExpiryDate }: ExpiryAlertBadgeProps) {
  if (!mdIsExpiringSoon) return null;

  const mdLabel = mdExpiryDate
    ? `Термін придатності спливає: ${mdExpiryDate}`
    : 'Термін придатності спливає';

  return (
    <Tooltip title={mdLabel}>
      <Badge
        count={<WarningOutlined style={{ color: '#fa8c16', fontSize: 14 }} />}
      />
    </Tooltip>
  );
}
